import "./modules/main/index";
import "./modules/account/index"
import "./modules/home/index"
import "./modules/admin/index"
import * as angular from "angular";
import "jquery-ui-sortable-only/jquery-ui.js"
import "pivottable";
import "pivottable/dist/gchart_renderers.min.js"

// load our default (non specific) css
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "ui-select/dist/select.css";
import "sweetalert/dist/sweetalert.css";
import "angular-ui-carousel/dist/ui-carousel.min.css";
import "angular-ui-grid/ui-grid.min.css";
import "./styles/style.scss";
import "./styles/screen.scss";
import "pivottable/dist/pivot.css"

if (TARGET === 'public') {
    angular.module("app", ["app.main", "app.account", "app.home"]);
}
else {
    angular.module("app", ["app.main", "app.account", "app.home", "app.admin"]);
}
angular.bootstrap(document, ["app"], {
    strictDi: true
});